
















































































































































import { watch, computed, defineComponent, toRef, ref, PropType, getCurrentInstance } from '@vue/composition-api';
import { SearchIcon, CheckIcon, CloseIcon, LoadingIcon } from 'tdesign-icons-vue';
import _ from 'lodash';
import i18n, { i18n_t } from '@/locales/i18n';
import dirListHandler from '@/renderer/components/dialog/SelectAnySpaceTargetFolder/compositions/dirListHandler';
import searchHandler from '@/renderer/components/dialog/SelectAnySpaceTargetFolder/compositions/searchHandler';
import selectSpaceHandler from '@/renderer/components/dialog/SelectAnySpaceTargetFolder/compositions/selectSpace';
import newFolderHandler from '@/renderer/components/dialog/SelectAnySpaceTargetFolder/compositions/newFolderHandler';
import { renderFileNameEle } from '@/renderer/scripts/composition/renderFileEle';
import tips from '@/renderer/scripts/utils/tips';
import spaceATM from '@/renderer/scripts/utils/AccessTokenManager/space';
import { SMH } from '@/renderer/scripts/smh';
type FileItemData = SMH.SpaceFileItemData;
const orginList: Array<{
  label: string;
  value: 'personal' | 'team' | 'group';
}> = [
  {
    label: i18n_t('个人空间'),
    value: 'personal',
  },
  {
    label: i18n_t('企业空间'),
    value: 'team',
  },
  {
    label: i18n_t('协作空间'),
    value: 'group',
  },
];
export default defineComponent({
  components: {
    SearchIcon,
    CheckIcon,
    CloseIcon,
    LoadingIcon,
  },
  props: {
    title: {
      String,
      default: i18n_t('选择路径'),
    },
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    isSearch: {
      type: Boolean,
      default: true,
    },
    onlyDir: {
      type: Boolean,
      default: false,
    },
    sync: {
      type: Boolean,
      default: false,
    },
    canChooseRoot: {
      type: Boolean,
      default: false,
    },
    canSelectPersonal: {
      type: Boolean,
      default: true,
    },
    checkedListProps: {
      type: Array,
      default: () => [],
    },
    checkable: {
      type: Boolean,
      default: false,
    },
    disableCheckOption: {
      type: Object,
      default: () => ({
        file: false,
        folder: false,
      }),
    },
    clickFolderAuthorityList: {
      required: true,
      type: Array as PropType<Array<keyof CoFile.AuthorityList>>,
    },
    selectfileOrFolderAuthorityList: {
      type: Array as PropType<Array<keyof CoFile.AuthorityList>>,
      default: () => [],
    },
    // 是否有协作空间下拉选项
    canSelectCoSpace: {
      type: Boolean,
      default: false,
    },
    // 下拉选项 个人空间、企业空间、协作空间 (用户传递，直接展示)
    selectOptions: {
      type: Array as PropType<Array<'personal' | 'team' | 'group'>>,
      default: () => [],
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = context.root.$store;
    // 当前组件
    const innerShow = computed({
      get: () => props.show,
      set: val => {
        context.emit('update:show', val);
      },
    });
    const isPersonal = computed(() => store.getters.editionFlag === 'personal');
    const showTooltip = ref(false);
    const preTeamId = ref('');
    const currTeamId = ref('');
    const checkedList = ref<FileItemData[]>([]); // 选中的文件列表
    const personSpaceId = ref('');
    const isEnterCoSpace = ref(false);
    const isPullGroup = computed(() => spaceType.value === 'group' && !isEnterCoSpace.value);
    const currentGroup = ref();
    const isSync = toRef(props, 'sync');
    const {
      teamTree,
      spaceType,
      isHasPersonalSpace,
      isPersonalSpaceType,
      isCoSpaceType,
      currentTeamNode,
      teamNodeCrumbs,
      methods: selectTeamMethods,
    } = selectSpaceHandler();

    /**
     * 当前所选空间的 spaceId
     */
    const spaceId = computed(() => {
      if (isPersonalSpaceType.value) {
        return personSpaceId.value;
      }
      if (isCoSpaceType.value) {
        return currentGroup.value?.spaceId || '';
      }
      return currentTeamNode.value.spaceId || '';
    });

    // 当前选中群组的spaceOrgId
    const spaceOrgId = computed(() => {
      if (isCoSpaceType.value) {
        return currentGroup.value?.orgId || '';
      }
      return store.getters.orgId || '';
    });
    const {
      dirHasMore,
      currentGroupList,
      currentSubDirList,
      dirCrumbs,
      dirPath,
      dirPathString,
      isLoading: listLoading,
      isGroupLoading,
      isDirMoreLoading,
      pageParams,
      methods: listMethods,
    } = dirListHandler(spaceId, spaceOrgId);
    const { newFolderName, isShowNewFolder, handeleCreateNewFolder, isShowNewFolderErrorTips, newFolderErrorTips } =
      newFolderHandler(spaceId);
    const {
      searchKey,
      searchType,
      isSearching,
      isSearchLoading,
      isLoadMoreLoading,
      isSearchDirChoose,
      isSearchDirCache,
      sentencesAboutSearch,
      searchResponse,
      methods: searchMethods,
    } = searchHandler(spaceId, isPersonalSpaceType);
    const optionsList = computed(() => {
      // 优先处理展示用户传递selectOptions, 不做权限后续逻辑的判断
      if (props.selectOptions.length) {
        const newList: Array<{
          label: string;
          value: 'personal' | 'team' | 'group';
        }> = [];
        props.selectOptions.forEach(item => {
          const originObj = orginList.find(val => val.value === item);
          if (originObj) {
            newList.push(originObj);
          }
        });
        return newList;
      }
      const coSpaceOptionsList = [
        {
          label: i18n_t('协作空间'),
          value: 'group',
        },
      ];
      if (isPersonal.value) {
        const personalOptionsList = [
          {
            label: i18n_t('个人空间'),
            value: 'personal',
          },
        ];
        return !props.canSelectCoSpace ? personalOptionsList : [...personalOptionsList, ...coSpaceOptionsList];
      }
      if (isHasPersonalSpace.value && props.canSelectPersonal) {
        const tmpOptionsList = [
          {
            label: i18n_t('个人空间'),
            value: 'personal',
          },
          {
            label: i18n_t('企业空间'),
            value: 'team',
          },
        ];
        return !props.canSelectCoSpace ? tmpOptionsList : [...tmpOptionsList, ...coSpaceOptionsList];
      }
      const teamOptionsList = [
        {
          label: i18n_t('企业空间'),
          value: 'team',
        },
      ];
      return !props.canSelectCoSpace ? teamOptionsList : [...teamOptionsList, ...coSpaceOptionsList];
    });
    const loading = computed(
      () =>
        // if (isSearching.value && searchData.list.length > 0) {
        //   return false;
        // }
        // listLoading.value || searchLoading.value
        listLoading.value || isGroupLoading.value,
    );
    const crumbs = computed(() => {
      let crumbs;
      if (isSearching.value) {
        crumbs = [
          {
            name: i18n_t('返回'),
            type: 'back',
          },
          {
            name: i18n_t('搜索结果'),
            type: 'null',
          },
        ];
      } else if (isPersonalSpaceType.value) {
        crumbs = [...dirCrumbs.value];
      } else if (isCoSpaceType.value) {
        const returnCrumbs = [
          {
            name: i18n_t('全部'),
            type: 'allGroup',
          },
        ];
        crumbs = isEnterCoSpace.value
          ? [...returnCrumbs, currentGroup.value, ...dirCrumbs.value.slice(1)]
          : [...returnCrumbs];
      } else {
        crumbs = [
          ...teamNodeCrumbs.value.map(item => ({
            type: 'team',
            ...item,
          })),
          ...dirCrumbs.value.slice(1),
        ];
      }
      // 超过3级，路径只保留一级和最后一级，其他省略
      const size = crumbs.length;
      if (size > 3) {
        const temp = [];
        temp.push(crumbs[0]);
        temp.push(crumbs[1]);
        const value = _.cloneDeep(crumbs[size - 2]);
        value.name = '...';
        value.type = 'omit';
        temp.push(value);
        temp.push(crumbs[size - 1]);
        crumbs = temp;
      }
      return crumbs.length
        ? crumbs
        : [
            {
              name: i18n_t('刷新'),
              type: 'refuse',
            },
          ];
    });
    const list = computed(() => {
      if (isSearching.value) {
        return searchResponse.contents.map(item => ({
          ...item,
          type: isSearchDirCache.value ? 'dir' : 'team',
        }));
      }
      // 查询协作空间全部群组时
      if (isPullGroup.value) {
        return currentGroupList.value.map(item => ({
          ...item,
          type: 'group',
        }));
      }
      const fileList = currentSubDirList.value;
      // 当为个人空间时 || 企业空间查询目录时 || 查询群组文件
      if (
        isPersonalSpaceType.value ||
        crumbs.value[crumbs.value.length - 1].type === 'dir' ||
        (isCoSpaceType.value && isEnterCoSpace.value)
      ) {
        return fileList;
      }
      // 企业空间需查询团队时
      const teamList = (currentTeamNode.value?.children || []).map(team => ({
        type: 'team',
        ...team,
      }));
      return [...teamList, ...(fileList as Array<any>)];
    });

    // 处于搜索态 || 正在新建文件夹 || 选择协作群组（未进入具体的协作群组时）
    const confirmDisabled = computed(() => isSearching.value || isShowNewFolder.value || isPullGroup.value);
    const methods = {
      async submit() {
        if (!dirPathString.value && !props.canChooseRoot) {
          showTooltip.value = true;
          return;
        }
        const targetDir = dirCrumbs.value[dirCrumbs.value.length - 1];
        const { authorityList } = targetDir;
        // 判断是否应有权限
        const flag = props.clickFolderAuthorityList.every(item => authorityList[item]);
        if (flag) {
          const options: Record<string, any> = {
            spaceId: spaceId.value,
            dirPath: dirPathString.value,
            fromSpace: spaceType.value,
          };
          if (isPersonalSpaceType.value) {
            options.totalPath = [i18n_t('个人空间'), dirPathString.value].filter(s => s).join('/');
            options.spaceId = personSpaceId.value;
          } else if (isCoSpaceType.value) {
            options.totalPath = [i18n_t('协作空间'), currentGroup.value.name, dirPathString.value]
              .filter(s => s)
              .join('/');
            options.spaceOrgId = spaceOrgId.value;
            options.groupId = currentGroup.value.id;
          } else {
            options.teamPath = teamNodeCrumbs.value.map(item => item.name).join('/');
            options.teamId = currTeamId.value;
            options.totalPath = [i18n_t('企业空间'), options.teamPath, dirPathString.value].filter(s => s).join('/');
          }
          context.emit('onSubmit', options);
        } else {
          tips.error(i18n_t('您没有操作该文件夹的权限'));
        }
      },
      // 这个是给同步盘用的上传方法
      submitSync() {
        if (!dirPathString.value && !props.canChooseRoot) {
          showTooltip.value = true;
          return;
        }
        const targetDir = dirCrumbs.value[dirCrumbs.value.length - 1];
        const { authorityList } = targetDir;
        const teamPath = teamNodeCrumbs.value
          .map((item, index) => item.name)
          .filter(s => s)
          .join('/');
        let teamId = +currTeamId.value;
        if (teamNodeCrumbs.value.length === 1) {
          teamId = currentTeamNode.value.id;
        }
        const completePath = isPersonalSpaceType.value
          ? dirPathString.value
          : [...teamNodeCrumbs.value.map((item, index) => item.name), dirPathString.value].filter(s => s).join('/');
        // 判断是否应有权限
        const flag = props.clickFolderAuthorityList.every(item => authorityList[item]);
        if (flag) {
          context.emit(
            'onSubmit',
            spaceType.value,
            isPersonalSpaceType.value ? personSpaceId.value : spaceId.value,
            completePath,
            dirPathString.value,
            spaceOrgId.value,
            teamId,
            teamPath,
          );
        } else {
          tips.error(i18n_t('您没有操作该文件夹的权限'));
        }
      },
      onSubmitEvent() {
        if (props.checkable) {
          return methods.onConfirmChecked();
        }
        if (isSync.value) {
          methods.submitSync();
        } else {
          methods.submit();
        }
      },
      onConfirmChecked() {
        if (checkedList.value.length === 0) {
          tips.info(i18n_t('请选择文件'));
          return;
        }
        context.emit('onSubmit', _.cloneDeep(checkedList.value));
      },
      onChangeCrumbs: (item: any, action: 'add' | 'remove' = 'add') => {
        let shadowCrumbs;
        // 省略类型需要还原倒数第二级的内容
        if (item.type === 'omit') {
          let tem_crumbs;
          if (isPersonalSpaceType.value) {
            tem_crumbs = [...dirCrumbs.value];
          } else {
            tem_crumbs = [
              ...teamNodeCrumbs.value.map(item => ({
                type: 'team',
                ...item,
              })),
              ...dirCrumbs.value.slice(1),
            ];
          }
          const size = tem_crumbs.length;
          if (size > 3) {
            item.name = tem_crumbs[size - 2].name;
            item.type = tem_crumbs[size - 2].type;
          }
        }
        if (item.type === 'team') {
          if (item.id === currentTeamNode.value.id) {
            dirCrumbs.clear(1);
            return;
          }
          shadowCrumbs = teamNodeCrumbs;
        } else if (item.type === 'allGroup') {
          isEnterCoSpace.value = false;
          currentGroup.value = [];
          dirCrumbs.clear();
          return;
        } else if (item.type === 'back') {
          searchMethods.onCancel();
          return;
        } else if (item.type === 'null') {
          return;
        } else {
          shadowCrumbs = dirCrumbs;
        }
        if (action === 'add') {
          shadowCrumbs.push(item);
        } else {
          shadowCrumbs.backTo(item);
        }
      },
      onClickItem: (item: any) => {
        if (isPullGroup.value) {
          isEnterCoSpace.value = true;
          currentGroup.value = item;
        }
        currTeamId.value = item?.id ? item.id : preTeamId.value;
        if (item?.id) {
          preTeamId.value = item?.id;
        }
        if (item.type === 'file') return;
        if (!isSearching.value) {
          methods.onChangeCrumbs(item);
          return;
        }
        searchMethods.onCancel();
        dirCrumbs.clear();
        if (item.type === 'dir') {
          // 检索团队空间的文件
          const { path } = item;
          const crumbs = path.map((name: string, index: number) => ({
            ...item,
            name,
            path: [...path].splice(0, index),
          }));
          [
            {
              type: 'all',
              name: '',
              path: [],
            },
            ...crumbs,
          ].forEach(crumb => {
            dirCrumbs.push(crumb);
          });
          return;
        }
        // 检索团队空间的团队
        teamNodeCrumbs.clear();
        teamNodeCrumbs.push(teamTree.value);
        teamNodeCrumbs.push(item);
      },
      pullList() {
        if (isPullGroup.value) {
          listMethods.pullGroupList(isPullGroup.value);
        } else {
          listMethods.pullDirList(props.onlyDir, false);
        }
      },
      onClickTooltipOutside() {
        showTooltip.value = false;
      },
      disableChecked(item: FileItemData): boolean {
        const {
          checkable,
          disableCheckOption: { file, folder },
        } = props;
        // 未开启选择功能 或 是企业名称
        if (!checkable || item.type === 'team') return true;
        const { authorityList, virusAuditStatus } = item;
        const flag = props.selectfileOrFolderAuthorityList.every(item => authorityList[item]);
        const virus = virusAuditStatus === 3; // 病毒文件暂不可选
        if (!flag || virus) return true;
        if (item?.type === 'dir') {
          return folder;
        }
        return file;
      },
      async onCheckedChange(item: FileItemData) {
        const flagIndex = checkedList.value.findIndex(
          val => this.getCurrentSpaceId() + val.path.join('/') === this.getCurrentSpaceId() + item.path.join('/'),
        );
        if (flagIndex !== -1) {
          checkedList.value = checkedList.value.filter((_, index) => index !== flagIndex);
        } else {
          checkedList.value.push({
            ...item,
            spaceId: this.getCurrentSpaceId(),
          });
        }
      },
      getCurrentSpaceId() {
        if (isPersonalSpaceType.value) {
          return personSpaceId.value;
        }
        return spaceId.value;
      },
      checkedFn(item: FileItemData) {
        // 如果该文件被禁用了，则不让选中
        if (methods.disableChecked(item)) return false;
        return checkedList.value
          .map(val => this.getCurrentSpaceId() + val.path.join('/'))
          .includes(this.getCurrentSpaceId() + item.path.join('/'));
      },
      loadMore() {
        // 搜索时的加载更多
        if (searchResponse.hasMore) {
          searchMethods.onLoadMore();
        } else if (dirHasMore.value) {
          // 查询文件时加载更多
          listMethods.onLoadMore(props.onlyDir);
        }
      },
      // 清除搜索，重新拉取列表数据
      handleClearInput() {
        searchKey.value = '';
        searchMethods.onSearch();
      },
      // 切换空间选择，重置面包屑
      clearSelectStatus() {
        isSearching.value = false;
        dirHasMore.value = false;
        searchResponse.hasMore = false;
        isEnterCoSpace.value = false;
        searchType.value = 'dir';
        dirCrumbs.clear();
        teamNodeCrumbs.clear();
      },
    };
    watch(
      () => innerShow.value,
      async value => {
        if (value) {
          const firstOption = optionsList.value[0];
          spaceType.value = firstOption.value as unknown as 'personal' | 'team' | 'group';
          if (props.checkable) {
            checkedList.value = _.cloneDeep((props.checkedListProps as FileItemData[]) || []);
          }
          if (isPersonalSpaceType.value) {
            personSpaceId.value = await spaceATM.getPersonalSpaceIdAsync();
          }
          methods.pullList();
          !isPersonal.value && selectTeamMethods.pullTeamNode(); // 个人版时不拉取团，以免spaceId不对应，保存网盘空间不对应
        } else {
          dirCrumbs.clear();
          teamNodeCrumbs.clear();
          searchKey.value = '';
          isSearching.value = false;
        }
      },
    );
    watch(spaceId, () => {
      dirCrumbs.clear();
    });
    watch(crumbs, (oldVal, newVal) => {
      if (!_.isEqual(oldVal, newVal) && innerShow.value) {
        methods.pullList();
      }
    });
    return {
      innerShow,
      isPersonal,
      isEnterCoSpace,
      crumbs,
      loading,
      isDirMoreLoading,
      list,
      showTooltip,
      renderFileNameEle,
      // 文件相关
      dirPath,
      confirmDisabled,
      // 空间相关
      isHasPersonalSpace,
      spaceType,
      isPersonalSpaceType,
      // 新建文件夹相关
      newFolderName,
      isShowNewFolder,
      handeleCreateNewFolder,
      isShowNewFolderErrorTips,
      newFolderErrorTips,
      dirHasMore,
      // 搜索相关
      searchKey,
      searchType,
      isSearching,
      isSearchLoading,
      isLoadMoreLoading,
      isSearchDirChoose,
      sentencesAboutSearch,
      searchResponse,
      ...searchMethods,
      ...methods,
      dirPathString,
      optionsList,
      isSync,
      checkedList,
    };
  },
});
